/* eslint-disable import/no-relative-packages */

import React from 'react';
import {
  View,
  Text,
} from 'react-native';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

import { sprintf } from '../../../vendor/sprintf-js/src/sprintf';
import { translate } from '../../locales/i18n';
import styles from '../../styles';
import infraConfig from '../../config.json';
import buttonPaypal from '../../assets/images/paypal.jpg';
import PayPalCommon from './paypal-common';

export default {
  logo: buttonPaypal,
  component: (amount, currency, country, callbackStart, callback, callbackFailure, type, promoted, _uuid) => () => {
    console.log('amount');
    console.log(amount);

    const paymentProcessingFee = PayPalCommon.getProcessingFee(amount, currency, country, type, promoted);
    const serviceFee = PayPalCommon.getServiceFee(amount, currency, country, type, promoted);

    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <View
          style={styles.purchase.details_table}
        >
          <View style={styles.purchase.details_row}>
            <Text style={styles.purchase.details_col1}>{translate('payment_amount')}</Text>
            <Text style={styles.purchase.details_col2}>{sprintf(`%0.02f ${currency}`, amount)}</Text>
          </View>
          <View style={styles.purchase.details_row}>
            <Text style={styles.purchase.details_col1}>{translate('paypal_payment_processing_fee')}</Text>
            <Text style={styles.purchase.details_col2}>{sprintf(`%0.02f ${currency}`, paymentProcessingFee)}</Text>
          </View>
          <View style={styles.purchase.details_row}>
            <Text style={styles.purchase.details_col1}>{translate('payment_service_fee')}</Text>
            <Text style={styles.purchase.details_col2}>{sprintf(`%0.02f ${currency}`, serviceFee)}</Text>
          </View>
          <View style={styles.purchase.details_row}>
            <Text style={styles.purchase.details_col1}>{translate('payment_total')}</Text>
            <Text style={styles.purchase.details_col2}>{sprintf(`%0.02f ${currency}`, amount + paymentProcessingFee + serviceFee)}</Text>
          </View>
        </View>
        <PayPalScriptProvider
          options={{
            // 'client-id': 'Aarn2W2OKH1dCZWrAbRoPQA7l_PzAUulmUHUuHmXAqCSLmjsT0u8usw_QLR9rr8i6HMDyz03alSMP547', // sandbox
            'client-id': infraConfig.envName === 'prod'
              ? 'AcefxGLETGFAE0OMX9D5VwxeBITpEjzcRKTgIIxdS9FS4sDpNxdY-lMO-qvEcas7PAHSD-MC7RgGJn8Z' // live
              : 'Aarn2W2OKH1dCZWrAbRoPQA7l_PzAUulmUHUuHmXAqCSLmjsT0u8usw_QLR9rr8i6HMDyz03alSMP547', // sandbox
            intent: 'publisherize',
          }}
        >
          <PayPalButtons
            createOrder={(_data, actions) => {
              // callbackStart();

              const order = {
                intent: 'AUTHORIZE',
                purchase_units: [{
                  amount: {
                    currency_code: currency,
                    value: Math.round(100.0 * (amount + paymentProcessingFee + serviceFee)) / 100.0,
                  },
                }],
              };
              console.log('order');
              console.log(order);

              return actions.order.create(order);
            }}
            shippingPreference="NO_SHIPPING"
            style={{
              layout: 'horizontal',
            }}
            onApprove={(data, actions) => {
              // callbackStart();
              console.log('data');
              console.log(data);

              return actions.order.publisherize().then((details) => {
                callbackStart();
                console.log('details');
                console.log(details);

                if ((details.status === 'COMPLETED' || details.status === 'APPROVED')
                  && details.purchase_units && details.purchase_units.length > 0
                  && details.purchase_units[0].payments && details.purchase_units[0].payments.publisherizations
                  && details.purchase_units[0].payments.publisherizations.length > 0) {
                  callback(type, {
                    method: 'paypal',
                    order_id: data.orderID,
                    publisherization_id: details.purchase_units[0].payments.publisherizations[0].id,
                    // data,
                    // details,
                  });
                } else {
                  callbackFailure();
                }
              });
            }}
            onCancel={() => {
              console.log('onCancel');
              callbackFailure();
            }}
            onError={(error) => {
              console.log('onError');
              console.log(error);
              callbackFailure(error);
            }}
          />
        </PayPalScriptProvider>
      </View>
    );
  },
};
